import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const OvertimeReport = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [totalWorkingDay, settotalWorkingDay] = useState(null);
  const [totalHoliday, setTotalHoliday] = useState(null);
  const [alert, setAlert] = useState(null);
  const [inputs, setInputs] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    status: "active",
  });
  const [salaryProcessMsg, setSalaryProcessMsg] = useState(null);
  const [salaryProcess, setSalaryProcess] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);
    Http.post("/attendance-report/", inputs)
      .then((res) => {
        console.log("API Response:", res.data); // Debug log

        if (res.data && res.data.result) {
          settotalWorkingDay(res.data.totalWorkingDay);
          setTotalHoliday(res.data.totalHolidayDay);
          setReceiveData(res.data.result);

          // Debug: Check first item
          if (res.data.result.length > 0) {
            console.log("First employee data:", res.data.result[0]);
            console.log(
              "attendanceWithoutHoliday:",
              res.data.result[0].attendanceWithoutHoliday
            );
            console.log(
              "holidayAttendance:",
              res.data.result[0].holidayAttendance
            );
          }
        } else {
          console.error("Unexpected API response structure:", res.data);
          setReceiveData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setReceiveData([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    setLoading(true);
    Http.post("/attendance-report/", inputs)
      .then((res) => {
        console.log("Form Submit Response:", res.data); // Debug log

        if (res.data && res.data.result) {
          settotalWorkingDay(res.data.totalWorkingDay);
          setTotalHoliday(res.data.totalHolidayDay);
          setReceiveData(res.data.result);

          // Debug: Check data after form submit
          if (res.data.result.length > 0) {
            console.log("Form Submit - First employee:", res.data.result[0]);
          }
        } else {
          console.error("Unexpected API response structure:", res.data);
          setReceiveData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Form Submit Error:", error);
        setReceiveData([]);
        setLoading(false);
      });
  };

  // Debug log before rendering
  console.log("Current receiveData:", receiveData);
  console.log("Total Working Days:", totalWorkingDay);
  console.log("Total Holidays:", totalHoliday);

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Attendance Report</h5>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-sm-40">
              <div className="row">
                <div className="col-lg">
                  <select
                    className="form-control"
                    name="year"
                    onChange={handleChange}
                    value={inputs.year}
                  >
                    <option value="">Select Year</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                    <option value="2030">2030</option>
                  </select>
                </div>
                <div className="col-lg">
                  <select
                    className="form-control"
                    name="month"
                    onChange={handleChange}
                    value={inputs.month}
                  >
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>
                <div className="col-lg">
                  <button
                    className="btn btn-primary btn-block mg-b-10"
                    onClick={formSubmit}
                    disabled={loading}
                  >
                    <i className="fa fa-send mg-r-10"></i>
                    {loading ? "Searching..." : "Search"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <div className="table-responsive p-0 pb-2">
                  <div className="col-lg">
                    <p className="text-center" style={{ color: "red" }}>
                      {salaryProcessMsg}
                    </p>
                  </div>
                  <div className="col-lg">
                    {loading ? (
                      <div className="text-center">
                        <ProgressSpinner />
                        <p>Loading attendance data...</p>
                      </div>
                    ) : (
                      <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 datatable">
                        <thead>
                          <tr>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              S/N
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Card No
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Name
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Designation
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Working Day
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Holiday Day
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Total Day
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Working Day Attendance
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Holiday Day Attendance
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Total Attendance
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Late Attendance
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Leave Application
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {receiveData && receiveData.length > 0 ? (
                            receiveData.map((item, index) => {
                              return (
                                <tr key={item.id || index}>
                                  <td className="text-xs">{index + 1}</td>
                                  <td className="text-xs">
                                    {item.card_no || "N/A"}
                                  </td>
                                  <td className="text-xs">
                                    {item?.name || "N/A"}
                                  </td>
                                  <td className="text-xs">
                                    {item.designation?.name || "N/A"}
                                  </td>
                                  <td className="text-xs">
                                    {totalWorkingDay || 0}
                                  </td>
                                  <td className="text-xs">
                                    {totalHoliday || 0}
                                  </td>
                                  <td className="text-xs">
                                    {(totalWorkingDay || 0) +
                                      (totalHoliday || 0)}
                                  </td>
                                  <td
                                    className="text-xs"
                                    style={{ backgroundColor: "#f0f0f0" }}
                                  >
                                    {item.attendanceWithoutHoliday !== null &&
                                    item.attendanceWithoutHoliday !== undefined
                                      ? item.attendanceWithoutHoliday
                                      : "No Data"}
                                  </td>
                                  <td
                                    className="text-xs"
                                    style={{ backgroundColor: "#f0f0f0" }}
                                  >
                                    {item.holidayAttendance !== null &&
                                    item.holidayAttendance !== undefined
                                      ? item.holidayAttendance
                                      : "No Data"}
                                  </td>
                                  <td className="text-xs">
                                    {(item.attendanceWithoutHoliday || 0) +
                                      (item.holidayAttendance || 0) || 0}
                                  </td>
                                  <td className="text-xs">
                                    {item.attendance_late_count || 0}
                                  </td>
                                  <td className="text-xs">
                                    {item.leaveApplication || "N/A"}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            !loading && (
                              <tr>
                                <td
                                  colSpan="12"
                                  className="text-center text-muted"
                                >
                                  No attendance data found
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OvertimeReport;
